// client/src/theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  // Customize Chakra UI theme as needed
});

export default theme;
